import React, { useState, useEffect } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/admin/createcamp.css";
import { useToast } from "../../context/toastContext";
import { useNavigate } from "react-router-dom";
import api from "../../services/apiClient";
import AdminSideNav from "../../components/layout/adminSideNav";
import DOMPurify from "dompurify";
import { useLocation, useParams } from "react-router-dom";
import DefaultImage from "../../assets/images/DefaultImage.png";
import NotAuthorizedMessage from "../../components/feedback/notAuthorizedMessage";
import countryOptions from "../../utils/countryOptions";

const EditCampPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const showToast = useToast();
    const { campID } = useParams();
    const [isSideNavActive, setisSideNavActive] = useState(false);
    const [userInfo, setUserInfo] = useState(
        JSON.parse(localStorage.getItem("AdminInfo")) || {}
    );
    const [campaign, setCampaign] = useState({
        name: "",
        type: "",
        category: "",
        trackingLink: "",
        previewLink: "",
        description: "",
        cutback: 0,
        cutbackStartAfter: 0,
        allowed_to: "Everyone",
        allowed_locations: ["Worldwide"],
        allowed_os: ["All"],
        totalCaps: "",
        perDayCaps: 0,
        goals: [{ goalName: "", objective: "", value: "", isMain: false }],
        securitySettings: { vpnAllowed: false, proxyAllowed: false, torAllowed: false, blockReferrer: false, capsPerPublisher: false, },
    });
    const [isPreviewActive, setisPreviewActive] = useState(false);
    const [optionWindowActive, setOptionWindowActive] = useState(null);
    const [isEditingCamp, setisEditingCamp] = useState(false);
    const [isEditedCamp, setisEditedCamp] = useState(false);
    const [autoParamatersAdjusterRunning, setAutoParamatersAdjusterRunning] = useState(false);
    const [suggestedUrl, setSuggestedUrl] = useState(null);
    const categoryOptions = [
        { label: "Finance", value: "Finance" },
        { label: "E-commerce", value: "E-commerce" },
        { label: "Social Media", value: "Social Media" },
        { label: "Healthcare", value: "Healthcare" },
        { label: "Education", value: "Education" },
        { label: "Entertainment", value: "Entertainment" },
        { label: "News", value: "News" },
        { label: "Gaming", value: "Gaming" },
        { label: "Productivity", value: "Productivity" },
        { label: "Lifestyle", value: "Lifestyle" },
        { label: "Travel", value: "Travel" },
        { label: "Food & Drink", value: "Food & Drink" },
        { label: "Real Estate", value: "Real Estate" },
        { label: "Business", value: "Business" },
        { label: "Technology", value: "Technology" },
        { label: "Sports", value: "Sports" },
        { label: "Music", value: "Music" },
        { label: "Art & Design", value: "Art & Design" },
        { label: "Dating", value: "Dating" },
        { label: "Job Portal", value: "Job Portal" },
        { label: "Government", value: "Government" },
        { label: "Non-Profit", value: "Non-Profit" },
        { label: "Automobile", value: "Automobile" },
        { label: "Home Services", value: "Home Services" },
        { label: "Legal", value: "Legal" },
        { label: "Fitness & Wellness", value: "Fitness & Wellness" },
        { label: "Parental & Childcare", value: "Parental & Childcare" },
        { label: "Marketplace", value: "Marketplace" },
        { label: "Subscription Services", value: "Subscription Services" },
        { label: "Cryptocurrency", value: "Cryptocurrency" },
        { label: "Stock Market", value: "Stock Market" },
        { label: "Security & Privacy", value: "Security & Privacy" },
        { label: "Transportation", value: "Transportation" },
        { label: "Weather", value: "Weather" },
        { label: "Events & Ticketing", value: "Events & Ticketing" },
        { label: "Augmented Reality", value: "Augmented Reality" },
        { label: "Virtual Reality", value: "Virtual Reality" },
        { label: "Artificial Intelligence", value: "Artificial Intelligence" },
        { label: "IoT & Smart Home", value: "IoT & Smart Home" },
    ];
    const allowedOptions = [
        { label: "Everyone", value: "Everyone" },
        { label: "Approved Once Only", value: "Approved Once Only" },
    ];
    const ObjectiveOptions = [
        { label: "CPI", value: "CPI" },
        { label: "CPR", value: "CPR" },
        { label: "CPA", value: "CPA" },
        { label: "CPD", value: "CPD" },
        { label: "CPL", value: "CPL" },
        { label: "CPS", value: "CPS" },
        { label: "CPV", value: "CPV" },
        { label: "CPM", value: "CPM" },
    ];

    const OSOptions = [
        { label: "All", value: "All" },
        { label: "Windows", value: "Windows" },
        { label: "Mac OS", value: "macOS" },
        { label: "iOS", value: "iOS" },
        { label: "Android", value: "Android" },
        { label: "Linux", value: "Linux" },
        { label: "Ubuntu", value: "Ubuntu" },
        { label: "Chrome OS", value: "Chrome OS" },
        { label: "Windows Phone", value: "Windows Phone" },
        { label: "BlackBerry", value: "BlackBerry" },
        { label: "FreeBSD", value: "FreeBSD" },
    ];

    const currencyOptions = [
        { label: "India Ruppe", value: "INR" },
        { label: "US Dollar", value: "USD" },
        { label: "Euro", value: "EUR" },
        { label: "Share", value: "SHARE" },
    ];

    const TRACKING_PLATFORMS = [
        {
            name: "Offer18",
            domains: ["o18.click", "trk.o18.link", "go.offer18.com"],
            requiredParams: {
                aff_click_id: "{click_id}",
            },
        },
        {
            name: "Trackier",
            domains: ["gotrackier.com", "trk.click", "trackier.link"],
            requiredParams: {
                p1: "{click_id}",
            },
        },
        {
            name: "Everflow",
            domains: ["tracking.everflow.io", "go.everflow.io", "trk.everflow.io"],
            requiredParams: {
                ef_click_id: "{click_id}",
            },
        },
        {
            name: "Voluum",
            domains: ["trk.voluum.com", "go.voluumtrk.com"],
            requiredParams: {
                cid: "{click_id}",
            },
        },
        {
            name: "Binom",
            domains: ["click.binom.net", "trk.binom.net"],
            requiredParams: {
                cid: "{click_id}",
            },
        },
        {
            name: "RedTrack",
            domains: ["track.redtrack.io", "go.redtrk.com"],
            requiredParams: {
                clickid: "{click_id}",
            },
        },
        {
            name: "Affise",
            domains: ["go.affise.com", "track.affise.com"],
            requiredParams: {
                sub1: "{click_id}",
            },
        },
        {
            name: "Cake",
            domains: ["trk.cake.net", "go.caketracking.com"],
            requiredParams: {
                s1: "{click_id}",
            },
        },
        {
            name: "Impact",
            domains: ["tracking.impact.com", "imp.i1100.net"],
            requiredParams: {
                subId1: "{click_id}",
            },
        },
        {
            name: "CJ Affiliate",
            domains: ["www.anrdoezrs.net", "www.kqzyfj.com", "www.jdoqocy.com"],
            requiredParams: {
                sid: "{click_id}",
            },
        },
        {
            name: "Partnerize",
            domains: ["prf.hn", "pnrtscr.com"],
            requiredParams: {
                clickref: "{click_id}",
            },
        },
        {
            name: "Rakuten",
            domains: ["click.linksynergy.com", "links.pjtra.com"],
            requiredParams: {
                u1: "{click_id}",
            },
        },
        {
            name: "ShareASale",
            domains: ["shareasale.com", "www.shareasale.com"],
            requiredParams: {
                afftrack: "{click_id}",
            },
        },
        {
            name: "AppsFlyer",
            domains: ["app.appsflyer.com", "impression.appsflyer.com"],
            requiredParams: {
                af_sub1: "{click_id}",
                pid: "{publisher_id}",
                c: "{campaign_id}",
            },
        },
        {
            name: "Adjust",
            domains: ["app.adjust.com"],
            requiredParams: {
                external_click_id: "{click_id}",
            },
        },
        {
            name: "Kochava",
            domains: ["control.kochava.com", "click.kochava.com"],
            requiredParams: {
                click_id: "{click_id}",
            },
        },
        {
            name: "Branch",
            domains: ["bnc.lt", "app.link"],
            requiredParams: {
                $click_id: "{click_id}",
            },
        },
        {
            name: "Menoceans",
            domains: ["menoceans.top", "lawyefsu.top", "hampigjun.top", "asketlzi.top"],
            requiredParams: {
                click_id: "{click_id}",
            },
        },
        {
            name: "ClickDealer",
            domains: ["fastdltrk.com"],
            requiredParams: {
                s1: "{publisher_id}",
                s2: "{click_id}",
            },
        },
    ];

    const PLACEHOLDER_MAP = {
        "%7Bclick_id%7D": "{click_id}",
        "%7Bpublisher_id%7D": "{publisher_id}",
        "%7Bcampaign_id%7D": "{campaign_id}",
    };

    useEffect(() => {
        const token = localStorage.getItem("aToken");
        if (!token) {
            navigate("/auth/login");
            return;
        }

        const campaign = location.state?.campaign;
        if (!campaign && !campID) {
            navigate("/admin/campaigns");
            return;
        } else {
            if (campaign.campaignId === campID) {
                setCampaign((prev) => ({
                    ...prev,
                    ...campaign,
                    allowed_to: campaign.approvedOnceOnly ? "Approved Once Only" : "Everyone",
                }));
            }
        }

        api
            .get(`/api/admin/info`)
            .then((response) => {
                setUserInfo(response.data.data);
                localStorage.setItem("AdminInfo", JSON.stringify(response.data.data));
                if (response.data.data.role !== "admin") return;
                api.get(`/api/a/campaign/${campaign.campaignId}`).then((res) => {
                    if (res.data.status) {
                        setCampaign((prev) => ({
                            ...prev,
                            ...res.data.campaign,
                            allowed_to: res.data.campaign.approvedOnceOnly ? "Approved Once Only" : "Everyone",
                        }));
                    } else {
                        showToast({
                            status: "error",
                            message: res.data.message || "Something went wrong.",
                        });
                        navigate("/admin/campaigns");
                    }
                }).catch((err) => {
                    showToast({
                        status: "error",
                        message: err.response?.data?.message || "Something went wrong.",
                    });
                    navigate("/admin/campaigns");
                });
            })
            .catch((err) => {
                showToast({
                    status: "error",
                    message: err.response?.data?.message || "Login not found.",
                });
                navigate("/auth/login");
            });
    }, [navigate, showToast, location.state?.campaign, campID]);

    const handleChange = (e) => {
        let { id, value } = e.target;

        setCampaign((prev) => ({ ...prev, [id]: DOMPurify.sanitize(value) }));
    };

    const toggleCountry = (country) => {
        setCampaign(prev => {
            const already = prev.allowed_locations.includes(country.value);

            return {
                ...prev,
                allowed_locations: already
                    ? prev.allowed_locations.filter(c => c !== country.value)
                    : [...prev.allowed_locations, country.value]
            };
        });
    };

    const selectedLabels = campaign.allowed_locations
        .map(val => countryOptions.find(c => c.value === val)?.label)
        .join(", ");

    const toggleOS = (os) => {
        setCampaign(prev => {
            const already = prev.allowed_os.includes(os.value);

            return {
                ...prev,
                allowed_os: already
                    ? prev.allowed_os.filter(c => c !== os.value)
                    : [...prev.allowed_os, os.value]
            };
        });
    };

    const selectedOsLabels = campaign.allowed_os
        .map(val => OSOptions.find(c => c.value === val)?.label)
        .join(", ");

    const handleGoalChange = (index, field, value) => {
        const sanitizedValue = DOMPurify.sanitize(value);
        if (field === "isMain" && sanitizedValue === "true") {
            setCampaign((prev) => {
                const updatedGoals = prev.goals.map((goal, idx) => ({
                    ...goal,
                    isMain: idx === index,
                }));
                return { ...prev, goals: updatedGoals };
            });
            return;
        }
        setCampaign((prev) => {
            const updatedGoals = [...prev.goals];
            updatedGoals[index][field] = sanitizedValue;
            return { ...prev, goals: updatedGoals };
        });
    };

    const addGoal = () => {
        setCampaign((prev) => {
            if (prev.goals.length >= 5) {
                showToast({
                    status: "error",
                    message: "Goals more than 5 are not allowed.",
                });
                return prev;
            }

            return {
                ...prev,
                goals: [
                    ...prev.goals,
                    { goalName: "", objective: "", value: "", isMain: false },
                ],
            };
        });
    };

    function detectPlatformByDomain(hostname) {
        return TRACKING_PLATFORMS.find((platform) =>
            platform.domains.some((domain) => hostname.includes(domain))
        );
    }

    function restorePlaceholders(url) {
        let fixedUrl = url;

        Object.entries(PLACEHOLDER_MAP).forEach(([encoded, raw]) => {
            fixedUrl = fixedUrl.replaceAll(encoded, raw);
        });

        return fixedUrl;
    }

    function isCurlyPlaceholder(value) {
        if (typeof value !== "string") return false;
        if (/^\{[^}]+\}$/.test(value)) return true;
        if (/^%7B[^%]+%7D$/i.test(value)) return true;

        return false;
    }

    function isEmptyValue(value) {
        return value === "";
    }

    function analyzeTrackingLink({
        rawUrl,
        forceChange = true,
    }) {
        let url;

        try {
            url = new URL(rawUrl);
        } catch {
            return {
                status: "error",
                message: "Invalid URL format",
            };
        }

        const platform = detectPlatformByDomain(url.hostname);
        const bannedKeys = new Set();

        if (!platform) {
            return {
                status: "unknown",
                message: "Unknown Tracking Platform",
            };
        }

        const searchParams = new URLSearchParams(url.search);

        for (const [key, value] of searchParams.entries()) {
            if (
                isEmptyValue(value) ||
                isCurlyPlaceholder(value)
            ) {
                bannedKeys.add(key);
                searchParams.delete(key);
            }
        }

        let requiresUserConfirmation = false;

        Object.entries(platform.requiredParams).forEach(
            ([paramKey, placeholder]) => {
                const existingValue = searchParams.get(paramKey);

                if (!existingValue) {
                    searchParams.set(paramKey, placeholder);
                    return;
                }

                if (existingValue !== placeholder) {
                    if (forceChange) {
                        searchParams.set(paramKey, placeholder);
                    } else {
                        requiresUserConfirmation = true;
                    }
                }
            }
        );

        const encodedUrl = `${url.origin}${url.pathname}?${searchParams.toString()}`;
        const suggestedUrl = restorePlaceholders(encodedUrl);

        return {
            status: "known",
            platform: platform.name,
            requiresUserConfirmation,
            suggestedUrl,
        };
    }

    const runAutoParamaterAjuster = () => {
        if (autoParamatersAdjusterRunning) return;
        setAutoParamatersAdjusterRunning(true);
        if (!campaign.trackingLink) {
            showToast({
                status: "error",
                message: "Tracking link is required.",
            });
            setAutoParamatersAdjusterRunning(false);
            return;
        }

        const result = analyzeTrackingLink({
            rawUrl: campaign.trackingLink,
            forceChange: true,
        });

        if (result.status === "unknown") {
            showToast({
                status: "error",
                message: result.message,
            });
            setAutoParamatersAdjusterRunning(false);
            return;
        }

        if (result.status === "known") {
            setSuggestedUrl(result.suggestedUrl);
            setAutoParamatersAdjusterRunning(false);
        }
    };

    const validateForm = () => {
        if (!campaign.name)
            return showToast({
                status: "error",
                message: "Campaign name is required",
            });

        if (!campaign.category)
            return showToast({
                status: "error",
                message: "Category is required.",
            });

        if (!campaign.type)
            return showToast({
                status: "error",
                message: "Type is required.",
            });

        if (!campaign.allowed_to)
            return showToast({
                status: "error",
                message: "Select who can access campaign.",
            });

        if (!campaign.totalCaps || campaign.totalCaps <= 0)
            return showToast({
                status: "error",
                message: "Caps Available must be a positive number",
            });

        if (campaign.perDayCaps < 0) {
            return showToast({
                status: "error",
                message: "Per Day Caps must be a positive number",
            });
        }

        if (campaign.cutback < 0) {
            return showToast({
                status: "error",
                message: "Cutback must be a positive number",
            });
        }

        if (campaign.cutbackStartAfter < 0) {
            return showToast({
                status: "error",
                message: "Cutback Start After must be a positive number",
            });
        }

        if (!campaign.allowed_locations || campaign.allowed_locations.length === 0) {
            return showToast({
                status: "error",
                message: "Select at least one allowed country.",
            });
        }

        if (!campaign.allowed_os || campaign.allowed_os.length === 0) {
            return showToast({
                status: "error",
                message: "Select at least one allowed Os.",
            });
        }

        const validValues = countryOptions.map(c => c.value);
        const invalid = campaign.allowed_locations.some(
            country => !validValues.includes(country)
        );

        if (invalid) {
            return showToast({
                status: "error",
                message: "Invalid country selection detected.",
            });
        }

        const urlRegex = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/;

        if (campaign.previewLink && !urlRegex.test(campaign.previewLink)) {
            return showToast({
                status: "error",
                message: "Invalid Preview link. Please enter a valid URL.",
            });
        }

        if (!campaign.trackingLink) {
            return showToast({
                status: "error",
                message: "Tracking link is required",
            });
        }

        if (!urlRegex.test(campaign.trackingLink)) {
            return showToast({
                status: "error",
                message: "Invalid tracking link. Please enter a valid URL.",
            });
        }

        if (!campaign.trackingLink.includes("{click_id}")) {
            return showToast({
                status: "error",
                message: "Tracking link must contain {click_id}.",
            });
        }

        if (campaign.description && campaign.description.length > 1000 && campaign.description.length < 10) {
            return showToast({
                status: "error",
                message: "Incorrect description length. Description must be between 10 to 1000 characters.",
            });
        }

        let numberOfMainGoal = 0;
        for (let i = 0; i < campaign.goals.length; i++) {
            if (!campaign.goals[i].goalName)
                return showToast({ status: "error", message: "Goal name is required" });
            if (!campaign.goals[i].objective)
                return showToast({
                    status: "error",
                    message: `${campaign.goals[i].goalName} Objective is not seleted`,
                });
            if (!campaign.goals[i].currency)
                return showToast({
                    status: "error",
                    message: `${campaign.goals[i].goalName} Currency is not seleted`,
                });
            const val = campaign.goals[i].value;

            if (val === "" || val == null || val < 0) {
                return showToast({
                    status: "error",
                    message: `${campaign.goals[i].goalName} Payout is not set.`,
                });
            }
            if (campaign.goals[i].isMain) {
                numberOfMainGoal++;
            }
        }

        if (!numberOfMainGoal)
            return showToast({
                status: "error",
                message: "Main goal is not defined.",
            });

        if (numberOfMainGoal > 1)
            return showToast({
                status: "error",
                message: "Only one goal can be main.",
            });

        const { vpnAllowed, proxyAllowed, torAllowed, blockReferrer, capsPerPublisher } = campaign.securitySettings;
        if (typeof vpnAllowed !== "boolean" || typeof proxyAllowed !== "boolean" || typeof torAllowed !== "boolean" || typeof blockReferrer !== "boolean" || typeof capsPerPublisher !== "boolean") {
            return showToast({
                status: "error",
                message: "Invalid security settings values.",
            });
        }

        setisPreviewActive(true);
    };

    const handelOptionSelection = (id, value) => {
        setCampaign((prev) => ({ ...prev, [id]: DOMPurify.sanitize(value) }));
        setOptionWindowActive(null);
    };

    const handelUpdateBtn = () => {
        if (isEditingCamp) return;
        if (isEditedCamp) return;
        setisEditingCamp(true);

        api
            .put(`/api/a/campaign/edit/${campID}`, campaign)
            .then((response) => {
                const fixedMessage = response.data.status
                    ? "Updated Successfully."
                    : "Something went wrong.";
                showToast({
                    status: response.data.status ? "success" : "error",
                    message: response.data.message || fixedMessage,
                });
                setisEditingCamp(false);
                if (response.data.status) {
                    setisEditedCamp(true);
                }
            })
            .catch((err) => {
                showToast({
                    status: "error",
                    message: err.response?.data?.message || "Something went wrong.",
                });
                setisEditingCamp(false);
            });
    };

    useEffect(() => {
        function handleClick(e) {
            const target = e.target;

            if (target.dataset.selector === "true") {
                return;
            }

            const insideSelection = target.closest(".selection-container");
            if (insideSelection) {
                return;
            }

            setOptionWindowActive(null);
        }

        window.addEventListener("click", handleClick);

        return () => {
            window.removeEventListener("click", handleClick);
        };
    }, []);

    return (
        <div className="createcamp__page">
            <AdminSideNav
                userName={userInfo.name}
                emailID={userInfo.email}
                active={isSideNavActive}
            />
            <div
                onClick={() => setisSideNavActive(!isSideNavActive)}
                className={
                    isSideNavActive ? "background-shadow active" : "background-shadow"
                }
            ></div>
            <main>
                <header className="desktop-header">
                    <div>
                        <h2>Edit Campaign</h2>
                        <p>Edit {campaign.name} campaign to your affilate network easily.</p>
                    </div>
                </header>

                <header className="mobile-header">
                    <div>
                        <h2>Edit Camp</h2>
                    </div>
                    <button
                        className="nav-btn"
                        onClick={() => setisSideNavActive(!isSideNavActive)}
                    >
                        {isSideNavActive ? (
                            <Icon name="XMark" className="onLeft" />
                        ) : (
                            <Icon name="Bars3" className="onLeft" />
                        )}
                    </button>
                </header>

                {userInfo && userInfo.role !== "admin" && (
                    <NotAuthorizedMessage />
                )}

                <div className="basic-form-container">
                    <h3>Basic Infos</h3>
                    <div className="full-size-box">
                        <label htmlFor="name">Campaign Name</label>
                        <input
                            type="text"
                            id="name"
                            placeholder="Enter your campaign name here"
                            value={campaign.name}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="full-size-inp-container">
                        <div className="half-inp-box">
                            <label htmlFor="category">Category</label>
                            <div className="inp-with-icon">
                                <input
                                    type="text"
                                    id="category"
                                    placeholder="Select category for campaign"
                                    data-selector="true"
                                    value={campaign.category}
                                    readOnly
                                    onClick={() =>
                                        setOptionWindowActive(
                                            optionWindowActive === "category" ? null : "category"
                                        )
                                    }
                                />
                                <Icon name="ChevronDown" />
                            </div>
                            <div
                                className={`selection-container ${optionWindowActive === "category" ? "active" : ""
                                    }`}
                            >
                                <div className="notch"></div>
                                {categoryOptions &&
                                    categoryOptions.length > 0 &&
                                    categoryOptions.map((category) => {
                                        return (
                                            <div
                                                key={category.value}
                                                className={`selection-box ${category.value === campaign.category ? "active" : ""
                                                    }`}
                                                onClick={() =>
                                                    handelOptionSelection("category", category.value)
                                                }
                                            >
                                                <span>{category.label}</span>
                                                <Icon name="Check" />
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                        <div className="half-inp-box">
                            <label htmlFor="type">Type</label>
                            <div className="inp-with-icon">
                                <input
                                    type="text"
                                    id="type"
                                    placeholder="Select type of campaign"
                                    data-selector="true"
                                    value={campaign.type}
                                    readOnly
                                    onClick={() =>
                                        setOptionWindowActive(
                                            optionWindowActive === "type" ? null : "type"
                                        )
                                    }
                                />
                                <Icon name="ChevronDown" />
                            </div>
                            <div
                                className={`selection-container ${optionWindowActive === "type" ? "active" : ""
                                    }`}
                            >
                                <div className="notch"></div>
                                {ObjectiveOptions &&
                                    ObjectiveOptions.length > 0 &&
                                    ObjectiveOptions.map((objective) => {
                                        return (
                                            <div
                                                key={objective.value}
                                                className={`selection-box ${objective.value === campaign.type ? "active" : ""
                                                    }`}
                                                onClick={() =>
                                                    handelOptionSelection("type", objective.value)
                                                }
                                            >
                                                <span>{objective.label}</span>
                                                <Icon name="Check" />
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                    <div className="full-size-inp-container">
                        <div className="half-inp-box">
                            <label htmlFor="access">Allowed To</label>
                            <div className="inp-with-icon">
                                <input
                                    type="text"
                                    id="access"
                                    placeholder="Select who can access this campaign"
                                    data-selector="true"
                                    value={campaign.allowed_to}
                                    readOnly
                                    onClick={() =>
                                        setOptionWindowActive(
                                            optionWindowActive === "allowed_to" ? null : "allowed_to"
                                        )
                                    }
                                />
                                <Icon name="ChevronDown" />
                            </div>
                            <div
                                className={`selection-container ${optionWindowActive === "allowed_to" ? "active" : ""
                                    }`}
                            >
                                <div className="notch"></div>
                                {allowedOptions &&
                                    allowedOptions.length > 0 &&
                                    allowedOptions.map((data) => {
                                        return (
                                            <div
                                                key={data.value}
                                                className={`selection-box ${data.value === campaign.allowed_to ? "active" : ""
                                                    }`}
                                                onClick={() =>
                                                    handelOptionSelection("allowed_to", data.value)
                                                }
                                            >
                                                <span>{data.label}</span>
                                                <Icon name="Check" />
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                        <div className="half-inp-box">
                            <label htmlFor="totalCaps">Caps Available</label>
                            <div className="inp-with-icon">
                                <input
                                    type="number"
                                    id="totalCaps"
                                    placeholder="Enter number of caps available"
                                    value={campaign.totalCaps}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="full-size-box">
                        <label htmlFor="perDayCaps">Per Day Caps</label>
                        <input
                            type="number"
                            id="perDayCaps"
                            placeholder="Enter per day caps"
                            min="1"
                            value={campaign.perDayCaps === 0 ? "" : campaign.perDayCaps}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="full-size-inp-container">
                        <div className="half-inp-box">
                            <label htmlFor="cutback">Cutback %</label>
                            <div className="inp-with-icon">
                                <input
                                    type="number"
                                    id="cutback"
                                    placeholder="Enter cutback you want to do"
                                    value={campaign.cutback === 0 ? "" : campaign.cutback}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="half-inp-box">
                            <label htmlFor="cutbackStartAfter">Cutback Start After</label>
                            <div className="inp-with-icon">
                                <input
                                    type="number"
                                    id="cutbackStartAfter"
                                    placeholder="Enter after what number of conversions you want to perform cutback"
                                    value={campaign.cutbackStartAfter === 0 ? "" : campaign.cutbackStartAfter}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="full-size-inp-container">
                        <div className="half-inp-box">
                            <label htmlFor="access">Allowed Places</label>
                            <div className="inp-with-icon">
                                <input
                                    type="text"
                                    id="access"
                                    placeholder="Select which countries campaign is for"
                                    data-selector="true"
                                    value={selectedLabels}
                                    readOnly
                                    onClick={() =>
                                        setOptionWindowActive(
                                            optionWindowActive === "allowed_locations" ? null : "allowed_locations"
                                        )
                                    }
                                />
                                <Icon name="ChevronDown" />
                            </div>
                            <div
                                className={`selection-container ${optionWindowActive === "allowed_locations" ? "active" : ""
                                    }`}
                            >
                                <div className="notch"></div>
                                {countryOptions &&
                                    countryOptions.length > 0 &&
                                    countryOptions.map((data) => {
                                        return (
                                            <div
                                                key={data.value}
                                                className={`selection-box ${campaign.allowed_locations.includes(data.value) ? "active" : ""
                                                    }`}
                                                onClick={() => toggleCountry(data)}
                                            >
                                                <span>{data.label}</span>
                                                <Icon name="Check" />
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>

                        <div className="half-inp-box">
                            <label htmlFor="access">Allowed Os</label>
                            <div className="inp-with-icon">
                                <input
                                    type="text"
                                    id="access"
                                    placeholder="Select which OS campaign is for"
                                    data-selector="true"
                                    value={selectedOsLabels}
                                    readOnly
                                    onClick={() =>
                                        setOptionWindowActive(
                                            optionWindowActive === "allowed_os" ? null : "allowed_os"
                                        )
                                    }
                                />
                                <Icon name="ChevronDown" />
                            </div>
                            <div
                                className={`selection-container ${optionWindowActive === "allowed_os" ? "active" : ""
                                    }`}
                            >
                                <div className="notch"></div>
                                {OSOptions &&
                                    OSOptions.length > 0 &&
                                    OSOptions.map((data) => {
                                        return (
                                            <div
                                                key={data.value}
                                                className={`selection-box ${campaign.allowed_os.includes(data.value) ? "active" : ""
                                                    }`}
                                                onClick={() => toggleOS(data)}
                                            >
                                                <span>{data.label}</span>
                                                <Icon name="Check" />
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                    <div className="full-size-box">
                        <label htmlFor="previewLink">Preview Link</label>
                        <input
                            type="url"
                            id="previewLink"
                            placeholder="Enter preview link here. (optional)"
                            value={campaign.previewLink}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="full-size-box">
                        <label htmlFor="trackingLink">Tracking Link</label>
                        <div className="inp-with-button">
                            <input
                                type="url"
                                id="trackingLink"
                                placeholder="Enter tracking link here."
                                value={campaign.trackingLink}
                                onChange={handleChange}
                            />
                            <button className="stick-on-right" onClick={runAutoParamaterAjuster}>Auto Adjust Paramaters</button>
                        </div>
                    </div>

                    {autoParamatersAdjusterRunning && (
                        <div className="auto-paramaters-adjuster-running">
                            <Icon name="Spinner" className="spin" />
                            <span>Adjusting Paramaters...</span>
                        </div>
                    )}

                    <div className={`suggested-tracking-link-container ${suggestedUrl ? "active" : ""}`}>
                        <div>
                            <span>Suggested Tracking Link:</span>
                            <code>{suggestedUrl ? suggestedUrl : "No Suggestions"}</code>
                        </div>
                        <button
                            onClick={() => {
                                setCampaign((prev) => ({
                                    ...prev,
                                    trackingLink: suggestedUrl,
                                }));
                                setSuggestedUrl(null);
                            }}
                        >
                            Apply Suggested Link
                        </button>
                    </div>

                    <div className="full-size-box">
                        <label htmlFor="trackingLink">Description</label>
                        <textarea
                            type="text"
                            id="description"
                            placeholder="Enter description here."
                            value={campaign.description}
                            onChange={handleChange}
                            rows={5}
                        />
                    </div>
                </div>
                <div className="goals-container">
                    <h3>Goals Infos</h3>
                    {campaign.goals.map((goal, index) => (
                        <div key={index} className="goals-info">
                            <div className="inp-box-container">
                                <label htmlFor={`goalName${index}`}>Goal Name</label>
                                <div className="inp-box">
                                    <input
                                        type="text"
                                        placeholder="Enter goal name here."
                                        id={`goalName${index}`}
                                        value={goal.goalName}
                                        onChange={(e) =>
                                            handleGoalChange(index, "goalName", e.target.value)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="inp-box-container">
                                <label htmlFor={`objective${index}`}>Objective</label>
                                <div className="inp-box icon-right">
                                    <input
                                        type="text"
                                        placeholder="Select objective."
                                        id={`objective${index}`}
                                        data-selector="true"
                                        value={goal.objective}
                                        readOnly
                                        onClick={() =>
                                            setOptionWindowActive(
                                                optionWindowActive === `objective${index}`
                                                    ? null
                                                    : `objective${index}`
                                            )
                                        }
                                    />
                                    <Icon name="ChevronDown" />
                                </div>
                                <div
                                    className={`selection-container ${optionWindowActive === `objective${index}` ? "active" : ""
                                        }`}
                                >
                                    <div className="notch"></div>
                                    {ObjectiveOptions &&
                                        ObjectiveOptions.length > 0 &&
                                        ObjectiveOptions.map((data) => {
                                            return (
                                                <div
                                                    key={data.value}
                                                    className={`selection-box ${data.value === goal.objective ? "active" : ""
                                                        }`}
                                                    onClick={() => {
                                                        handleGoalChange(index, "objective", data.value);
                                                        setOptionWindowActive(null);
                                                    }}
                                                >
                                                    <span>{data.label}</span>
                                                    <Icon name="Check" />
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>

                            <div className="inp-box-container">
                                <label htmlFor={`objective${index}`}>Currency</label>
                                <div className="inp-box icon-right">
                                    <input
                                        type="text"
                                        placeholder="Select Currency."
                                        id={`objective${index}`}
                                        data-selector="true"
                                        value={goal.currency}
                                        readOnly
                                        onClick={() =>
                                            setOptionWindowActive(
                                                optionWindowActive === `currency${index}`
                                                    ? null
                                                    : `currency${index}`
                                            )
                                        }
                                    />
                                    <Icon name="ChevronDown" />
                                </div>
                                <div
                                    className={`selection-container ${optionWindowActive === `currency${index}` ? "active" : ""
                                        }`}
                                >
                                    <div className="notch"></div>
                                    {currencyOptions &&
                                        currencyOptions.length > 0 &&
                                        currencyOptions.map((data) => {
                                            return (
                                                <div
                                                    key={data.value}
                                                    className={`selection-box ${data.value === goal.currency ? "active" : ""
                                                        }`}
                                                    onClick={() => {
                                                        handleGoalChange(index, "currency", data.value);
                                                        setOptionWindowActive(null);
                                                    }}
                                                >
                                                    <span>{data.label}</span>
                                                    <Icon name="Check" />
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>

                            <div className="inp-box-container">
                                <label htmlFor={`payout${index}`}>Payout</label>
                                <div className="inp-box icon-left">
                                    <Icon name="Ruppe" />
                                    <input
                                        type="number"
                                        placeholder="0"
                                        id={`payout${index}`}
                                        value={goal.value}
                                        onChange={(e) =>
                                            handleGoalChange(index, "value", e.target.value)
                                        }
                                    />
                                </div>
                            </div>
                            <div className="checkbox-container">
                                <label>Final Goal</label>
                                <div
                                    className={`main-checkbox ${goal.isMain ? "checked" : ""}`}
                                    onClick={() =>
                                        handleGoalChange(index, "isMain", !goal.isMain)
                                    }
                                >
                                    {goal.isMain && <Icon name="Check" />}
                                </div>
                            </div>

                            <button
                                className="remove-goal-btn"
                                onClick={() => {
                                    setCampaign((prev) => {
                                        if (prev.goals.length === 1) {
                                            showToast({
                                                status: "error",
                                                message: "At least one goal is required.",
                                            });
                                            return prev;
                                        }

                                        const updatedGoals = prev.goals.filter((_, idx) => idx !== index);
                                        return { ...prev, goals: updatedGoals };
                                    });
                                }}
                                disabled={campaign.goals.length === 1}
                            >
                                <span>Remove Goal</span>
                                <Icon name="XMark" />
                            </button>
                        </div>
                    ))}
                    <button className="add-goal" onClick={addGoal}>
                        <Icon name="Plus" /> Add Goal
                    </button>
                </div>

                <div className="security-settings-container">
                    <h3>Security Settings</h3>
                    <div className="checkbox-container">
                        <label>VPN Allowed</label>
                        <div
                            className={`main-checkbox ${campaign.securitySettings.vpnAllowed ? "checked" : ""}`}
                            onClick={() =>
                                setCampaign((prev) => ({
                                    ...prev,
                                    securitySettings: {
                                        ...prev.securitySettings,
                                        vpnAllowed: !prev.securitySettings.vpnAllowed,
                                    },
                                }))
                            }
                        >
                        </div>
                    </div>
                    <div className="checkbox-container">
                        <label>Proxy Allowed</label>
                        <div
                            className={`main-checkbox ${campaign.securitySettings.proxyAllowed ? "checked" : ""}`}
                            onClick={() =>
                                setCampaign((prev) => ({
                                    ...prev,
                                    securitySettings: {
                                        ...prev.securitySettings,
                                        proxyAllowed: !prev.securitySettings.proxyAllowed,
                                    },
                                }))
                            }
                        >
                        </div>
                    </div>
                    <div className="checkbox-container">
                        <label>Tor Allowed</label>
                        <div
                            className={`main-checkbox ${campaign.securitySettings.torAllowed ? "checked" : ""}`}
                            onClick={() =>
                                setCampaign((prev) => ({
                                    ...prev,
                                    securitySettings: {
                                        ...prev.securitySettings,
                                        torAllowed: !prev.securitySettings.torAllowed,
                                    },
                                }))
                            }
                        >
                        </div>
                    </div>

                    <div className="checkbox-container">
                        <label>Block Referrer</label>
                        <div
                            className={`main-checkbox ${campaign.securitySettings.blockReferrer ? "checked" : ""}`}
                            onClick={() =>
                                setCampaign((prev) => ({
                                    ...prev,
                                    securitySettings: {
                                        ...prev.securitySettings,
                                        blockReferrer: !prev.securitySettings.blockReferrer,
                                    },
                                }))
                            }
                        >
                        </div>
                    </div>

                    <div className="checkbox-container">
                        <label>Limit Caps To Per Publisher</label>
                        <div
                            className={`main-checkbox ${campaign.securitySettings.capsPerPublisher ? "checked" : ""}`}
                            onClick={() =>
                                setCampaign((prev) => ({
                                    ...prev,
                                    securitySettings: {
                                        ...prev.securitySettings,
                                        capsPerPublisher: !prev.securitySettings.capsPerPublisher,
                                    },
                                }))
                            }
                        >
                        </div>
                    </div>
                </div>

                <div className="btn-container">
                    <button onClick={validateForm} className="ReviewBtn">
                        <Icon name="DocumentText" /> Review & Update
                    </button>
                </div>

                <div
                    className={`background-shadow above-side-nav ${isPreviewActive ? "active" : ""
                        }`}
                ></div>
                <div className={`preview-container ${isPreviewActive ? "active" : ""}`}>
                    <div className="notch"></div>
                    <div className="profile-info-container">
                        <img src={DefaultImage} alt="Swift Digital Ads Logo" />
                        <div>
                            <h3>{campaign.name || "Not Set"}</h3>
                            <p>
                                {campaign.allowed_to === "Everyone"
                                    ? "Anyone can access it."
                                    : "Only approved publishers can run."}
                            </p>
                        </div>
                    </div>
                    <div className="infos-container">
                        <div className="info">
                            <span>Catrgory</span>
                            <span>{campaign.category || "Not Set"}</span>
                        </div>
                        <div className="info">
                            <span>Type</span>
                            <span>{campaign.type || "Not Set"}</span>
                        </div>
                        <div className="info">
                            <span>Total Caps</span>
                            <span>{campaign.totalCaps || "Not Set"}</span>
                        </div>
                        <div className="info">
                            <span>Tracking link</span>
                            <span>{campaign.trackingLink || "Not Set"}</span>
                        </div>
                        <div className="info">
                            <span>{campaign.goals.length > 1 ? "Goals" : "Goal"}</span>
                            <span>
                                {campaign.goals.map((goal) => goal.goalName).join(",") ||
                                    "Not Set"}
                            </span>
                        </div>
                    </div>
                    <div className="buttons-container">
                        <button
                            disabled={isEditingCamp}
                            onClick={() => setisPreviewActive(false)}
                        >
                            <Icon name="Pencil" /> Edit
                        </button>
                        <button
                            disabled={isEditedCamp || isEditingCamp}
                            onClick={handelUpdateBtn}
                        >
                            {isEditingCamp ? (
                                <Icon name="ArrowPath" className="spin" />
                            ) : (
                                <Icon name="RocketLaunch" />
                            )}
                            {isEditedCamp
                                ? "Updated"
                                : isEditingCamp
                                    ? "Updating..."
                                    : "Update"}
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default EditCampPage;